export const getAccessToken = () => {
    const TokenKeyAuth = JSON.parse(localStorage.getItem("auth"));

    return `Bearer ${TokenKeyAuth}`
}